import { addToast } from '@octano/global-ui';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { Card } from 'reactstrap';

import { useLayoutState } from '../../../../hooks/useLayoutState';
import { PathsLayouts } from '../../../../config/routes';
import { Partnership } from '../api/partnership';
import { PartnershipForm } from './parts/PartnershipForm';

const PartnershipFormView = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { id } = useParams<{ id?: string }>();
  const { hideTabs, showTabs } = useLayoutState();
  const prefix = 'tariffAndTuition.partnerships';

  const recordToEdit: Partnership | null = id
    ? ({ id: Number(id) } as Partnership)
    : null;

  useEffect(() => {
    hideTabs();
    return () => {
      showTabs();
    };
  }, [hideTabs, showTabs]);

  const handleSubmit = (result: any) => {
    if (result.data) {
      addToast({
        icon: 'check',
        text: id
          ? t(`${prefix}.updatedSuccess`)
          : t(`${prefix}.createdSuccess`),
        color: 'success',
      });
      history.push(`${PathsLayouts.tariffAndTuiton}/partnerships`);
    } else {
      addToast({
        icon: 'error',
        text: t(`${prefix}.saveError`),
        color: 'danger',
      });
    }
  };

  const handleCancel = () => {
    history.push(`${PathsLayouts.tariffAndTuiton}/partnerships`);
  };

  return (
    <Card className="mx-3">
      <PartnershipForm
        recordToEdit={recordToEdit}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </Card>
  );
};

export default PartnershipFormView;
